import { render, staticRenderFns } from "./kc-archive-cats-resources-items.vue?vue&type=template&id=6cb50b1c&scoped=true&"
import script from "./kc-archive-cats-resources-items.vue?vue&type=script&lang=js&"
export * from "./kc-archive-cats-resources-items.vue?vue&type=script&lang=js&"
import style0 from "./kc-archive-cats-resources-items.vue?vue&type=style&index=0&id=6cb50b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb50b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bartlomiejewiak/56degrees/Projekty/gv-health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb50b1c')) {
      api.createRecord('6cb50b1c', component.options)
    } else {
      api.reload('6cb50b1c', component.options)
    }
    module.hot.accept("./kc-archive-cats-resources-items.vue?vue&type=template&id=6cb50b1c&scoped=true&", function () {
      api.rerender('6cb50b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/kc-archive-cats-resources-items.vue"
export default component.exports